import { CanMatchFn } from "@angular/router";

export const authLayoutGuard: CanMatchFn = (route, segments) => {
    const path = segments[0]?.path;
    return path === "userDetails" || path === "designer";
};
